import React from 'react';
import Card from '../../components/Card/Card';
import Table from '../../components/Table/Table';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import TablePreRender from '../../components/Table/Table.prerender';
import {
    weightedAverageMMUtil,
    mkWeightedAverageBondUtil,
    weightedAverageUtilFI
} from './util';

import styles from './WeightedAverage.css';
import {
    WEIGHTED_AVERAGE_MM,
    WEIGHTED_AVERAGE_BOND,
    WEIGHTED_AVERAGE_ETF
} from './queries';

const getQueryAndDataFunc = (moneyMarket, isFI, dspWorstLabel) => {
    if (moneyMarket) {
        return { query: WEIGHTED_AVERAGE_MM, func: weightedAverageMMUtil };
    }

    if (isFI) {
        return {
            query: WEIGHTED_AVERAGE_ETF,
            func: weightedAverageUtilFI(dspWorstLabel)
        };
    }

    return {
        query: WEIGHTED_AVERAGE_BOND,
        func: mkWeightedAverageBondUtil(dspWorstLabel)
    };
};

const WeightedAverage = ({ ticker, moneyMarket, dspWorstLabel, isFI }) => {
    const { query, func } = getQueryAndDataFunc(
        moneyMarket,
        isFI,
        dspWorstLabel
    );

    return (
        <div className="section-container">
            <Card>
                <div className="subsection-no-border">
                    <div className="distribution-schedule">
                        <GqlQueryWrapper
                            query={query}
                            variables={{ ticker }}
                            dataFunc={func}
                            placeholder={() => <TablePreRender />}
                        >
                            {({ data }) =>
                                isFI ? (
                                    <React.Fragment>
                                        <TitleWithDescription title="Effective Maturity" />
                                        <div className="maturity-table">
                                            <Table
                                                data={data}
                                                customClassName="weighted-average"
                                                rowBars
                                            />
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <Table
                                        data={data}
                                        customClassName="weighted-average"
                                        rowBars
                                    />
                                )
                            }
                        </GqlQueryWrapper>
                    </div>
                </div>
            </Card>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WeightedAverage;
